import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/60">
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1280px] mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-primary-500"></i>
            </div>
            <span className="text-lg font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              43423漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                isActive('/') ? 'text-primary-500' : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/rexue"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                isActive('/about') ? 'text-primary-500' : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className="pl-9 pr-4 py-2 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 w-48 transition-all"
              />
            </div>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/60 py-4 flex flex-col gap-3 px-2">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className={`text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap cursor-pointer ${
                isActive('/') ? 'bg-primary-50 text-primary-600' : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/rexue"
              onClick={() => setMobileOpen(false)}
              className={`text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category') ? 'bg-primary-50 text-primary-600' : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              onClick={() => setMobileOpen(false)}
              className={`text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap cursor-pointer ${
                isActive('/about') ? 'bg-primary-50 text-primary-600' : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
            <div className="relative mt-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2.5 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
              />
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}